"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwliWidget = exports.ApplicationWorkflowThankYouBackButtons = exports.RichTextViewer = exports.CommonControlsSectionHeader = exports.CommonControlsImage = exports.LayoutControlsPanel = exports.ApplicationWorkflowThankYou = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var Image_1 = require("player-common-controls/controls/Image");
Object.defineProperty(exports, "CommonControlsImage", { enumerable: true, get: function () { return Image_1.Image; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var player_rich_text_viewer_1 = require("player-rich-text-viewer");
exports.RichTextViewer = player_rich_text_viewer_1.default;
var ApplicationWorkflowThankYouBackButtons_1 = require("../ApplicationWorkflowThankYouBackButtons/ApplicationWorkflowThankYouBackButtons");
Object.defineProperty(exports, "ApplicationWorkflowThankYouBackButtons", { enumerable: true, get: function () { return ApplicationWorkflowThankYouBackButtons_1.ApplicationWorkflowThankYouBackButtons; } });
var AwliWidget_1 = require("../AwliWidget/AwliWidget");
Object.defineProperty(exports, "AwliWidget", { enumerable: true, get: function () { return AwliWidget_1.AwliWidget; } });
var ApplicationWorkflowThankYou = (function (_super) {
    __extends(ApplicationWorkflowThankYou, _super);
    function ApplicationWorkflowThankYou(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowThankYou.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationWorkflowThankYou.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationWorkflowThankYou.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationWorkflowThankYou.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationWorkflowThankYou.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationWorkflowThankYou.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowThankYou.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowThankYou.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowThankYou.prototype.render = function () {
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            var pixel_handler = function () {
                var pixel_result = $this.state.viewModel.actionItem.trackingPixels.map(function (pixel, pixel$index) {
                    $this.state.viewModel.pixel = pixel;
                    $this.state.viewModel.pixel$index = pixel$index;
                    return [React.createElement(Image_1.Image, { key: pixel$index.toString() + 0, alt: "", src: $this.state.viewModel.pixel, size: "Responsive" })];
                });
                delete $this.state.viewModel.pixel;
                delete $this.state.viewModel.pixel$index;
                return pixel_result;
            };
            return [React.createElement(Panel_1.Panel, { key: 0, horizontalAlign: "Center", paddingBottom: "Large", tag: $this.state.viewModel.parentTag, children: [React.createElement(PlayerVisible, { key: 0, visible: $this.state.viewModel.isDefaultImageVisible, children: [React.createElement(Image_1.Image, { key: 0, size: "Responsive", src: $this.state.viewModel.image, alt: $this.state.viewModel.actionItem.title })] }), React.createElement(Panel_1.Panel, { key: 1, paddingBottom: "Small", children: [React.createElement(SectionHeader_1.SectionHeader, { key: 0, size: "H2", text: $this.state.viewModel.actionItem.title })] }), React.createElement(Panel_1.Panel, { key: 2, paddingBottom: "Medium", children: [React.createElement(player_rich_text_viewer_1.default, { key: 0, allowedTags: $this.state.viewModel.constants.PRTV_ALLOWED_TAGS, allowedAttributes: $this.state.viewModel.constants.PRTV_ALLOWED_ATTRIBUTES, html: $this.state.viewModel.actionItem.note })] }), React.createElement(Panel_1.Panel, { key: 3, paddingBottom: "Xlarge", children: [React.createElement(player_rich_text_viewer_1.default, { key: 0, allowedTags: $this.state.viewModel.constants.PRTV_ALLOWED_TAGS, allowedAttributes: $this.state.viewModel.constants.PRTV_ALLOWED_ATTRIBUTES, html: $this.state.viewModel.actionItem.instructions })] }), React.createElement(ApplicationWorkflowThankYouBackButtons_1.ApplicationWorkflowThankYouBackButtons, { key: 4, areButtonsEnabled: $this.state.viewModel.areButtonsEnabled, backToSearchText: $this.state.viewModel.backToSearchText, backToSearchUrl: $this.state.viewModel.backToSearchUrl, createProfileText: $this.state.viewModel.createProfileText, createProfileUrl: $this.state.viewModel.createProfileURL, isCreateProfileVisible: $this.state.viewModel.isCreateProfileVisible }), pixel_handler(), React.createElement(PlayerVisible, { key: 6, visible: $this.state.viewModel.applyWithLinkedInShowConversionWidget, children: [React.createElement(AwliWidget_1.AwliWidget, { key: 0, enabled: $this.state.viewModel.applyWithLinkedInShowConversionWidget, apiKey: $this.state.viewModel.applyWithLinkedInApiKey, integrationContext: $this.state.viewModel.applyWithLinkedInIntegrationContext, buttonMode: "CONVERSION" })] })] })];
        };
        return (React.createElement("div", { className: "p-view-applicationworkflowthankyou" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationWorkflowThankYou.defaultProps = {
        actionItem: "", showProfileButton: "", jobTitle: "", careerSiteId: "", reqId: "", isCareerSiteResponsive: "", createProfileURL: "", thankYouText: "", successText: "", createProfileText: "", backToSearchText: "", isCareerCenter: "", searchQueryParameters: "",
        onDataChanged: function () { }
    };
    return ApplicationWorkflowThankYou;
}(React.Component));
exports.ApplicationWorkflowThankYou = ApplicationWorkflowThankYou;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowThankYou"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowThankYou/ApplicationWorkflowThankYou.js
// module id = 411
// module chunks = 0 2